import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const navItems = [
  { label: 'Solutions', to: '/services' },
  { label: 'Products', to: '/products' },
  { label: 'Academy', to: '/academy' },
  { label: 'Case Studies', to: '/case-studies' },
  { label: 'About', to: '/about' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [location.pathname]);

  return (
    <>
      <a className="sync-skip-link" href="#app-content">Skip to main content</a>
      <header className="sync-header">
        <div className="sync-shell sync-header-inner">
          <Link to="/" className="sync-brand" aria-label="Nalexus Technologies home">
            <img src="/assets/img/nalexus-logo-tp.png" alt="Nalexus Technologies" />
          </Link>

          <button
            className="sync-menu-toggle"
            type="button"
            aria-expanded={open}
            aria-controls="primary-navigation"
            onClick={() => setOpen((value) => !value)}
          >
            <span className="sync-menu-toggle-label">Menu</span>
            <span aria-hidden="true">{open ? '×' : '☰'}</span>
          </button>

          <nav id="primary-navigation" className={`sync-nav ${open ? 'is-open' : ''}`} aria-label="Primary navigation">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => (isActive ? 'is-active' : undefined)}
              >
                {item.label}
              </NavLink>
            ))}
            <Link className="sync-button sync-button-small" to="/contact?intent=demo">
              Request a demo
            </Link>
          </nav>
        </div>
      </header>
    </>
  );
}
